module.exports = __webpack_public_path__ + "img/venta_1.6e8539ee.png";